
import ChoroplethLegend from '@/components/MapLayers/ChoroplethLegend.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ChoroplethLayerOptionType } from '@/types/modules/MapLayerTypes.type';
import { DataFilterMutations } from '@/store/mutations/dataFilterMutations';
import { filterSectors } from '@/assets/data/dataFilterOptions';
import { DataFilterActions } from '@/store/actions/dataFilterActions';

@Component({
  components: { ChoroplethLegend },
})
export default class VisualizationSettings extends Vue {
  @Prop({ type: Number, required: true }) readonly lowerLegendHeight!: number;

  collapsed = false;

  get choroplethLayers(): ChoroplethLayerOptionType[] {
    return this.$store.getters.choroplethLayers;
  }

  get selectedOption() {
    return this.$store.getters.selectedChoroplethLayer.selectedLayer;
  }

  set selectedOption(newVal: ChoroplethLayerOptionType) {
    this.$store.commit('setSelectedChoroplethLayer', newVal);
  }

  get selectedSub() {
    return this.$store.getters.selectedChoroplethLayer.scenario;
  }

  set selectedSub(nevVal) {
    this.$store.commit('setSelectedChoroplethLayerScenario', nevVal);
  }

  // upon selection of a new value select the first sup categorory
  resetSubCatOption(newVal: ChoroplethLayerOptionType) {
    newVal.options.length < 0
      ? (this.selectedSub = newVal.options[0].value)
      : (this.selectedSub = 'a');
    this.layerSelectionChanged();
  }

  layerSelectionChanged() {
    const environmentalAndRecRiskLayerIds = [
      'coldWaterFish',
      'warmWaterFish',
      'wetRiparian',
      'plainsFish',
    ];
    if (environmentalAndRecRiskLayerIds.includes(this.selectedOption.id)) {
      // auto select the Environmental & Recreational sector and apply the filter
      this.$store.commit(
        DataFilterMutations.SET_SELECTED_SECTOR,
        filterSectors.find(s => s.key === 'environRec') ?? null,
      );
      this.$store.dispatch(DataFilterActions.SET_DATA_FILTER);
    }

    this.$emit('layerSelectionChanged', this.selectedOption.showNodes);
  }
}
